import { oneBtnPopupCreator } from '../../popups/ConfirmPopup/helper';

export const displayPopupMessageInformation = (message = '') => {
  message &&
    oneBtnPopupCreator({
      content: {
        main: message,
        iconPath: '/images/green-clipboard.svg',
      },
      btnConfig: 'CLOSE',
    });
};
